import { z } from 'zod';

// Minimal organization schema intended to be used for validating joined entities.
// We keep both the internal organization id and the platform (HighBond) id so
// features can pass the correct identifier to external services (e.g. Bifrost).
export const minimalOrganizationSchema = z.object({
  id: z.string(),
  highbondId: z.string().optional(),
});
export type MinimalOrganizationEntity = z.infer<
  typeof minimalOrganizationSchema
>;
